import React, { forwardRef } from 'react'

import { ColumnProps } from './column.types'
import { useStyle } from './column.styles'

export const Column = forwardRef<HTMLDivElement, ColumnProps>(
  (
    {
      alignItems,
      children,
      className,
      justifyContent,
      fullHeight,
      fullFilledHeight,
      fullWidth,
      ...props
    },
    ref
  ) => {
    const classes = useStyle({
      alignItems,
      justifyContent,
      fullHeight,
      fullWidth,
      fullFilledHeight
    })

    return (
      <div
        className={`${className || ''} ${classes.column}`}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    )
  }
)
